import { ALICUOTA, FORMATO_VENTA, MODALIDAD } from 'Constants'

export const FORM_HOME = (
  data,
  handleChange,
  edit,
  dataBefore,
  permissions,
  productList,
  responsable,
  cuit
) => {
  const comprobanteSeleccionado = dataBefore.data.tipo_comprobante.find(
    (comprobante) => comprobante.id === data.comprobante
  )
  const formatoVentaLabel = FORMATO_VENTA.find((f) => f.id === Number(data.formato_venta))?.label
  const allEnvio =
    productList.length > 0 && productList.every((item) => item.descripcion === 'ENVIO')
  const ESTADO = [
    {
      id: 1,
      label: 'Borrador',
    },
    {
      id: 3,
      label: 'Confirmado',
    },
  ]
  const estadoPedido = ESTADO.find((f) => f.id === Number(data.estado))?.label

  return [
    {
      class: 'textfield',
      type: 'number',
      name: 'id',
      label: 'CUIT',
      value: cuit,
      disabled: true,
      sm: 3,
      xs: 12,
      size: 'small',
    },
    {
      class: 'textfield',
      name: 'tipo_responsable',
      label: 'Tipo de responsable',
      value: responsable,
      disabled: true,
      sm: 3,
      xs: 12,
      size: 'small',
    },
    {
      class: 'textfield',
      sm: 3,
      xs: 12,
      name: 'formato_venta',
      label: 'Formato de venta',
      value: formatoVentaLabel,
      disabled: true,
      size: 'small',
    },
    {
      class: 'autocomplete',
      sm: 3,
      xs: 12,
      name: 'modalidad',
      label: 'Modalidad',
      optionValue: 'label',
      options: MODALIDAD,
      optionLabel: `options["label"]`,
      value: allEnvio ? 'Reintegro de gastos' : data.modalidad,
      disabled: [2, 7, 20, 202, 207, 3, 8, 21, 203, 208].includes(data.comprobante)
        ? true
        : permissions.allowEditModalidad && !permissions.allowEditMin
          ? !edit
          : true,
      size: 'small',
      onChange: (e) => handleChange('modalidad', e.label),
    },
    {
      class: 'autocomplete',
      sm: 2,
      xs: 12,
      name: 'alicuota',
      label: 'Alicuota (%)',
      optionValue: 'label',
      options: ALICUOTA,
      optionLabel: `options["label"]`,
      value: data.alicuota,
      disabled: permissions.allowEditMin ? true : !edit,
      size: 'small',
      onChange: (e) => handleChange('alicuota', e.label),
    },
    {
      class: 'autocomplete',
      sm: 2,
      xs: 12,
      name: 'estado',
      label: 'Estado',
      optionValue: 'label',
      options: ESTADO,
      optionLabel: `options["label"]`,
      value: estadoPedido,
      disabled: permissions.allowEditMin ? true : !edit,
      size: 'small',
      onChange: (e) => handleChange('estado', e.id),
    },
    {
      class: 'textfield',
      sm: 3,
      xs: 12,
      name: 'comprobante',
      label: 'Tipo de comprobante',
      value: comprobanteSeleccionado.largo,
      disabled: true,
      size: 'small',
    },
    {
      class: 'textfield',
      sm: 2,
      xs: 12,
      name: 'nro_comprobante',
      label: 'Nº de comprobante',
      value: data.nro_comprobante,
      disabled: true,
      size: 'small',
    },
    {
      class: 'textfield',
      name: 'observaciones',
      label: 'Observación',
      value: data.observaciones,
      disabled: permissions.allowEditMin ? true : !edit,
      sm: 3,
      xs: 12,
      size: 'small',
      onChange: (e) => {
        handleChange('observaciones', e.target.value)
      },
    },
  ]
}
